import React, { useState } from 'react';
import AdminSidebar from '../../components/admin/dashboard/adminsidebar/AdminSidebar';
// import Topbar from '../../components/admin/dashboard/admintopbar/AdminTopbar';
import '../../assets/css/screens/serviceprovider/layouts/adminmasterlayout/AdminMasterLayout.css';

const AdminMasterLayout = ({ children }) => {
  // const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  // const [activeMenu, setActiveMenu] = useState('Adminhome');

  // const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);
  const [activeMenu, setActiveMenu] = useState(null); // ✅ Must be here
const [isSidebarOpen, setIsSidebarOpen] = useState(false);

const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="admin-master-layout">
      {/* ✅ Pass props correctly */}
      <AdminSidebar
  isOpen={isSidebarOpen}       // ✅ Controls sidebar visibility
  toggleSidebar={toggleSidebar} // ✅ Function to open/close sidebar
  activeMenu={activeMenu}       // ✅ Pass current active menu id
  setActiveMenu={setActiveMenu} // ✅ Function to update active menu
/>

      <div className="main-wrapper">
        {/* <Topbar onMenuClick={toggleSidebar} /> */}
        <main className="main-content">{children}</main>
      </div>

      {isSidebarOpen && (
        <div className="sidebar-overlay" onClick={closeSidebar}></div>
      )}
    </div>
  );
};

export default AdminMasterLayout;
